module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "lds-ellipsis"
  }, [_c('div'), _c('div'), _c('div'), _c('div')]), _vm._v(" "), _c('div', [_vm._v("Indlæser")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1bc34b89", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bc34b89"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/loader.vue
// module id = 792
// module chunks = 0